import axios from 'axios';
import { apiTransitionLogin, loginSuccess } from '../../../actions/fauluLoanCalculator/auth';

export const loginService = (store, next, action) => {
    (async () => {
            store.dispatch(apiTransitionLogin.pending());
            try {
                const resp = await calculate();
                store.dispatch(loginSuccess(resp.data));
                store.dispatch(apiTransitionLogin.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionLogin.failure());
            }
    })();
    return next(action);
};


const calculate = async () => {
    try {
        const url = '/om-api/ug-motor-insurance/ug/login';
        return await axios.get(url, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
